<script setup lang="ts">
withDefaults(defineProps<{
  eyebrow?: string
  title: string
  description?: string
  compact?: boolean
}>(), {
  eyebrow: '',
  description: '',
  compact: false,
})
</script>

<template>
  <section class="public-page-intro" :class="{ 'public-page-intro--compact': compact }">
    <div class="public-page-intro__inner">
      <h1>{{ title }}</h1>
      <p v-if="description" class="public-page-intro__description">{{ description }}</p>
      <slot />
    </div>
  </section>
</template>

<style scoped lang="scss">
.public-page-intro{
  padding: clamp(2.75rem, 6vw, 4.75rem) 1.5rem;
  color: white;
  background: $public-surface;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.public-page-intro--compact{
  padding-block: clamp(2.25rem, 5vw, 3.75rem);
}

.public-page-intro__inner{
  width: min(100%, $public-content);
  margin: 0 auto;
  text-align: left;
}

h1{
  margin: 0;
  color: white;
  max-width: 18ch;
  font-size: clamp(2.35rem, 5vw, 3.85rem);
  font-weight: 600;
  line-height: 1;
  letter-spacing: -0.025em;
}

.public-page-intro__description{
  max-width: $public-reading;
  margin: 1.1rem 0 0;
  color: $public-text-muted;
  font-size: clamp(1rem, 1.8vw, 1.125rem);
  line-height: 1.6;
}
</style>
